var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M14,8a6,6,0,1,0,6,6A6,6,0,0,0,14,8Zm0-6A12,12,0,1,0,26,14,12,12,0,0,0,14,2Zm0,21.6A9.6,9.6,0,1,1,23.6,14,9.6,9.6,0,0,1,14,23.6Z","transform":"translate(-2 -2)","fill":"#3d8824"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }